/* ==========================================================================
   carousel.js — horizontal product carousel
   Native CSS scroll-snap + JS arrow buttons that scroll by card width.
   Arrows auto-disable at start/end of scroll.
   ========================================================================== */

(() => {
  'use strict';

  const scroll = document.querySelector('[data-carousel-scroll]');
  const prev   = document.querySelector('[data-carousel-prev]');
  const next   = document.querySelector('[data-carousel-next]');

  if (!scroll || !prev || !next) return;

  /** How far to shift on click — roughly one card + gap. */
  const getStep = () => {
    const firstCard = scroll.querySelector('.product-card');
    if (!firstCard) return scroll.clientWidth * 0.8;
    const gap = parseFloat(getComputedStyle(scroll).columnGap || '16') || 16;
    return firstCard.getBoundingClientRect().width + gap;
  };

  const updateArrowState = () => {
    const maxScroll = scroll.scrollWidth - scroll.clientWidth;
    prev.disabled = scroll.scrollLeft <= 1;
    next.disabled = scroll.scrollLeft >= maxScroll - 1;
  };

  prev.addEventListener('click', () => {
    scroll.scrollBy({ left: -getStep(), behavior: 'smooth' });
  });
  next.addEventListener('click', () => {
    scroll.scrollBy({ left:  getStep(), behavior: 'smooth' });
  });

  scroll.addEventListener('scroll', updateArrowState, { passive: true });
  window.addEventListener('resize', updateArrowState);
  // Initial state after layout settles
  requestAnimationFrame(updateArrowState);
})();
